import { AuditLogRepository } from '../ports/AuditLogRepository';

export class GetStaffActivityLogsUseCase {
  constructor(private repository: AuditLogRepository) {}

  async execute(ownerId: string, staffId?: string, maxItems: number = 50) {
    if (!ownerId) throw new Error('OwnerId is required');
    return await this.repository.getStaffActivityLogs(ownerId, staffId, maxItems);
  }
}
